module.exports = __webpack_public_path__ + "static/img/map-jp.c925d53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/map-jp.png
// module id = LWUg
// module chunks = 0